export default class SingleLike {
    
    
    static get selector() {
        return '.single__like';
    }

    constructor(el) {
        this.el = el;
        this.setEvents();
        this.isActive = false;
        if(this.isLiked()) this.active();
    }

    isLiked() {
        let id = document.body.dataset.postid

        let actionStorage = localStorage.getItem('vo-likepage');
        if(actionStorage) {
            actionStorage = JSON.parse(actionStorage);
            return actionStorage.includes(parseInt(id));
        }
        return false;
    }

    active() {
        this.el.classList.add('single__like--active');
    }

    setEvents() {
        this.el.addEventListener('click', this.e_click.bind(this));
    }

    e_click(e) {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('vegout-like'));
        this.active();
    }

}